import { createAction } from 'redux-actions';
import {
  INFORMATION_LIST_FETCH,
  INFORMATION_LIST_SUCCESS,
  INFORMATION_LIST_FAILURE,
  DELETE_INFORMATION_FETCH,
  DELETE_INFORMATION_SUCCESS,
  DELETE_INFORMATION_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-INFORMATIONS--->>>
export const informationListFetch = createAction(INFORMATION_LIST_FETCH);
export const informationListSuccess = createAction(INFORMATION_LIST_SUCCESS);
export const informationListFailure = createAction(INFORMATION_LIST_FAILURE);

export const fetchInformations = () => async dispatch => {
  dispatch(informationListFetch());
  try {
    const res = await api.get('information');
    dispatch(informationListSuccess(res.data));
  } catch (error) {
    dispatch(informationListFailure(error));
  }
};

//<<<---DELETE-INFORMATION--->>>
export const deleteInformationFetch = createAction(DELETE_INFORMATION_FETCH);
export const deleteInformationSuccess = createAction(
  DELETE_INFORMATION_SUCCESS
);
export const deleteInformationFailure = createAction(
  DELETE_INFORMATION_FAILURE
);

export const deleteInformation = (id, lang, callback) => async dispatch => {
  dispatch(deleteInformationFetch());
  try {
    const res = await api.post(`information/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteInformationSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteInformationFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/InformationList/actions.js